// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-container .ant-tabs-bar {\n  border-bottom: none !important;\n  margin-bottom: 30px !important;\n}\n.login-container .ant-input-affix-wrapper .ant-input:not(:first-child) {\n  padding-left: 35px !important;\n}\n.mul-select-dropdown {\n  width: 180px !important;\n}", ""]);
// Exports
module.exports = exports;
